export default __webpack_public_path__ + "fonts/427bfde662afd33bc551499c93d36613.woff2";